<template>
  <div class="dnn-download-box">
    <el-tooltip
      class="item"
      effect="dark"
      :content="
        fileUrl ? (fileName ? fileName : btnLabel) : '目前没有可用的下载文件'
      "
      placement="top"
    >
      <el-button
        class="dnn-downLoadBtn"
        :loading="loading"
        :icon="icon"
        @click="downLoad"
        v-if="btnType === 'btn'"
        :disabled="!fileUrl"
        >{{ btnLabel }}</el-button
      >
      <el-button class="dnn-downLoadBtn-text" type="text" v-else>
        {{ btnLabel }}
      </el-button>
    </el-tooltip>
  </div>
</template>

<script>
import { downLoadFile } from "@/api/api";
import { downLoadCount } from "@/api/website";
import LargeFileDownloader from "@/utils/downLoadLargeFile.js";
import { baseURL } from "@/utils/env.js";
export default {
  name: "DownLoad",
  props: {
    fileUrl: {
      type: String,
      default: "",
      // required: true,
    },
    id: {
      type: String,
      default: "0",
    },
    type: {
      type: String,
      default: "1",
    },
    fileName: {
      type: String,
      default: "file",
    },
    btnLabel: {
      type: String,
      default: "下载",
    },
    icon: {
      type: String,
      default: "el-icon-download",
    },
    btnType: {
      type: String,
      default: "btn", // text文字按钮
    },
  },
  data() {
    return {
      loading: false,
      // downLoadFileInstance: null,
      suffix: "",
    };
  },
  created() {
    // this.downLoadFileInstance = new LargeFileDownloader({
    //   fileUrl: this.fileUrl,
    //   fileName: this.fileName,
    //   onDownloadSuccess: () => {
    //     this.loading = false;
    //     downLoadCount({
    //       type: this.type,
    //       id: this.id,
    //     });
    //   },
    //   onDownloadProgress: (progress) => {
    //     console.log("下载进度--", progress + "%");
    //   },
    //   onDownloadError: () => {
    //     this.loading = false;
    //   },
    // });
  },
  methods: {
    downLoad() {
      console.log("this.fileUrl--", this.fileUrl);
      console.log("this.fileName--", this.fileName);
      if (!this.fileUrl) return;
      this.loading = true;
      downLoadCount({
        type: this.type,
        id: this.id,
      });
      // downLoadCount 此接口不会返回结果，设置延迟，避免接口被刷掉
      setTimeout(() => {
        this.loading = false;
        window.open(
          baseURL +
            "/dnn/openapi/download?downloadUrl=" +
            this.fileUrl +
            "&fileName=" +
            this.fileName,
          "_blank",
        );
      }, 100);

      // this.loading = true;
      // this.downLoadFileInstance.startDownload();

      // downLoadFile(this.fileUrl)
      //   .then((res) => {
      //     // let fileName = this.$uniFun.getFileName(this.fileUrl);
      //     this.$uniFun.downloadFile(res, this.fileName);
      //   })
      //   .catch((e) => {
      //     console.log("err--", err);
      //     this.$message.error("资源请求错误");
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //     downLoadCount({
      //       type: this.type,
      //       id: this.id,
      //     });
      //   });
    },
  },
};
</script>

<style lang="scss">
.dnn-download-box {
  display: inline-block;
  .dnn-downLoadBtn {
    padding: 8px 12px;
    border-color: #1d1d1f;
    color: #1d1d1f;
    font-size: 14px;
    &:hover {
      background: transparent;
      border-color: #0035fb;
      color: #0035fb;
    }
    &:focus {
      border-color: #1d1d1f;
      color: #1d1d1f;
      background: transparent;
    }
  }
  .dnn-downLoadBtn-text.el-button--text {
    display: block;
    padding: 0;
    color: rgba(255, 255, 255, 0.6);
    background: transparent;
    &:hover {
      color: #0035fb;
      text-decoration: underline;
    }
    &.el-button + .el-button {
      margin: 0;
    }
  }
}
</style>
